import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { SECTION_TYPE } from 'src/app/app.constants';
import { AdminRepositoryService } from 'src/app/services/admin-repository.service';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { UserRepositoryService } from 'src/app/services/user-repository.service';
import { CreateEditDialog, HomePageContents, Links } from 'src/app/shared/models/admin.model';


@Component({
  selector: 'app-create-edit-section-dialog',
  templateUrl: './create-edit-section-dialog.component.html',
  styleUrls: ['./create-edit-section-dialog.component.scss']
})
export class CreateEditSectionDialogComponent implements OnInit {
  sectionUserForm: UntypedFormGroup;
  submitted = false;
  linkTypeOptions = ['Document', 'URL'];
  linkTypeSelected: string;
  isLoadingData: boolean;
  linkList:Links[]=[];
  payloadArray={
    enabled:false
  }
  private linkListAddress:string;
  private unsubscribe: Subject<void> = new Subject<void>(); 
  modalHeaderTitle: string;
  isEdit: boolean;
  section = SECTION_TYPE.HomeSectionsManagement
  homePageConentsList: any;
  resultArray: Links[];
  prevList: any;
  enableButtonOnCrossClick: boolean = true;
  isExtensionNotValid: boolean;
  constructor(private userRepository: UserRepositoryService, 
              private fb: UntypedFormBuilder,private snackBarService: SnackBarService,
              private adminRepository: AdminRepositoryService,
              private dialogRef: MatDialogRef<CreateEditSectionDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: CreateEditDialog,
              ) {
                 
               }

   ngOnInit(): void {
    this.linkTypeSelected = this.linkTypeOptions[0];
    this.modalHeaderTitle = this.data.isEdit  === true ? 'Edit Section' : 'Add Section';
    this.isEdit = this.data.isEdit === true ? true : false;
    this.sectionFormInitialize();
    if(this.data.isEdit){
      this.loadTableData();
    } else {
      this.sectionUserForm.controls.orderSequence.setValue(this.data.activeCount);
    }
  }
  
  loadTableData() { 
    this.isLoadingData = true;   
    this.adminRepository.getAllHomePageConents(this.section)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((homePageConents: HomePageContents) => {
        if(homePageConents) {
          this.homePageConentsList = homePageConents;
          if(this.homePageConentsList.length > 0){
            this.updateForm();
          }
          this.isLoadingData = false; 
        }
      });
  }

  sectionFormInitialize() {   
    this.sectionUserForm = this.fb.group({
      sectionName: new UntypedFormControl('', [Validators.required]),
      sectionDescription: new UntypedFormControl('', [Validators.required]),
      linkListGroup: this.fb.group({
        linkName: new UntypedFormControl(''),
        linkType: new UntypedFormControl(''),
        url: new UntypedFormControl(''),
        fileUpload: new UntypedFormControl('')
      }),
      orderSequence: new UntypedFormControl(''),
      isActive: new UntypedFormControl(true)
    });
    this.linkListGroup.valueChanges.pipe(debounceTime(500), distinctUntilChanged())
      .subscribe(val => {
          if(val.linkType == 'URL') {
            if(val.linkName !== '' && val.linkType !== '' && val.url !== '') {
              this.payloadArray.enabled = true;
            } else {
              this.payloadArray.enabled = false;
            }
          } else {
            if(val.linkName !== '' && val.linkType !== '' && val.fileUpload !== '') {
              this.payloadArray.enabled = true;
            } else {
              this.payloadArray.enabled = false;
            }
          }
      });
  }

  onOptionChange(event) {
    this.linkTypeSelected = event.value;
  }

  onSaveClick() {
   this.isLoadingData = true;
   let contentForm = this.getContentFormDetails();
    let saveForm: HomePageContents = {
      sectionId: this.data.isEdit? this.data.data.sectionId:'',
      sectionDetailJson: {
        staticContentName:'HomeSectionsManagement',
        sectionHeader: contentForm.sectionHeader,
        sectionDescription: contentForm.sectionDescription,
        orderSequence: this.orderSequence.value,
        sectionOrder: 0,
        links: this.linkList
      },
     comments: null,
     isActive: contentForm.isActive
    }
    if(!this.data.isEdit) {
    this.adminRepository.saveStaticContent(saveForm)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(data => {
        if (data) {
          this.dialogRef.close(true);
          this.snackBarService.showSuccess('Home Section Content has been successfully added/updated');
          this.isLoadingData = false;
        }
      }, err => {
        this.dialogRef.close(false);
        this.isLoadingData = false;
      });
    } else {
      this.adminRepository.editStaticContent(saveForm)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(data => {
        if (data) {
          this.dialogRef.close(true);
          this.snackBarService.showSuccess('Home Section Content has been successfully added/updated');
          this.isLoadingData = false;
        }
      }, (error) => {
        if (error.status == 400) { 
          this.snackBarService.showError("Invalid input!");
          this.isLoadingData = false;
        }
        else {
          this.dialogRef.close(false);
          this.isLoadingData = false;
        }
      });
    }
  }

  getContentFormDetails() {
    return {
        sectionHeader: this.sectionName.value,
        sectionDescription: this.sectionDescription.value,
        linkName: this.linkName.value,
        linkType: this.linkType.value,
        url: this.url.value,
        isActive: this.data.isEdit?this.isActive.value == false ? 'No' : 'Yes' : true,
    }
  }

  onCancelClick() {
    if (this.data.isEdit) {
      const lp = this.homePageConentsList.filter(a => a.sectionId == this.data.data.sectionId);
      this.prevList = lp[0].sectionDetailJson.links;
      this.resultArray = this.linkList.filter((item) => {
        return !this.prevList.some((prevItem) => {
          return prevItem.linkAddress == item.linkAddress;
        });
      });
      if (this.resultArray.length > 0) {
        this.removeLinkList();
      }
    }
    this.dialogRef.close();
  }

  onUploadFile(){
    let linkList: any = new Object();
    linkList.linkTitle = this.linkName.value;
    linkList.linkType = this.linkTypeSelected;
    if (this.linkTypeSelected === "URL") {
      linkList.linkAddress = this.url.value;
    } else {
      linkList.linkAddress = this.linkListAddress;
    }
    this.linkList.push(linkList);
    this.linkName.patchValue("");
    this.fileUpload.patchValue("");
    this.url.patchValue("");
  }

  onFileSelected(event){
      const  file:File=event.target.files[0];
      this.linkName.setValue(file.name)
      let formData: FormData = new FormData();
      formData.append("file", file);
      this.adminRepository.uploadStaticFile(formData).pipe(takeUntil(this.unsubscribe))
      .subscribe(
     (response:string) => {
      this.linkListAddress=response;
      },
     (error) => {
      if(error.status == 405) {
        this.payloadArray.enabled = false;
        this.isExtensionNotValid = true;
      } else {
        console.log(error);
      }
     }
   );
  }

  removeLinkList(ind?:number){
    let removeLinks = [];
    if(!this.data.isEdit) {
      if (ind && this.linkList[ind].linkType === "URL") {
        this.linkList.splice(ind, 1);
      } else {
        this.linkList.splice(ind, 1);
      }
    } else {
      if(ind && this.linkList[ind].linkType === "URL") {
        this.linkList.splice(ind, 1);
        //removeLinks.push(this.linkList[ind].linkAddress)
      } else {
        this.linkList.splice(ind, 1);
      }
    }
    // if (ind && this.linkList[ind].linkType === "URL") {
    //   this.linkList.splice(ind, 1);
    // } 
    //else {
      // if(this.data.isEdit) {
      //   if(ind) {
      //     removeLinks.push(this.linkList[ind].linkAddress)
      //    } else {
      //       this.resultArray.forEach(a => removeLinks.push(a.linkAddress));
      //    }
      // } else {
      //   removeLinks.push(this.linkList[ind].linkAddress)
      // }       
      // this.adminRepository
      //   .removeStaticContentFile(removeLinks)
      //   .pipe(takeUntil(this.unsubscribe))
      //   .subscribe(
      //     (response: any) => {
      //       if(this.data.isEdit) {
      //         ind && ind != undefined ? this.linkList.splice(ind, 1) : this.linkList.splice(this.prevList.length, this.resultArray.length);
      //       } else {
      //         this.linkList.splice(ind, 1);
      //       }
      //     },
      //     (error) => {
      //       console.log(error);
      //     }
      //   );
   // }
    this.enableButtonOnCrossClick = false;
  }
 private updateForm(){
    
    if(this.homePageConentsList.length > 0) {
    const sectionLinks = this.homePageConentsList.filter(a => a.sectionId == this.data.data.sectionId);
    this.sectionName.patchValue(sectionLinks[0].sectionDetailJson.sectionHeader);
    this.sectionDescription.patchValue(sectionLinks[0].sectionDetailJson.sectionDescription);
    this.isActive.patchValue(sectionLinks[0].isActive == 'No' ? false : true);
    this.orderSequence.patchValue(sectionLinks[0].sectionDetailJson.orderSequence);
    this.linkList = sectionLinks[0].sectionDetailJson.links;
    }
    //this.homePageConentsList.sectionDetailJson.links
 }
  get sectionName() {
    return this.sectionUserForm.get('sectionName') as UntypedFormControl;
  }

  get sectionDescription() {
    return this.sectionUserForm.get('sectionDescription') as UntypedFormControl;
  }

  get linkName() {
    return this.sectionUserForm.get('linkListGroup.linkName') as UntypedFormControl;
  }

  get linkType() {
    return this.sectionUserForm.get('linkListGroup.linkType') as UntypedFormControl;
  }

  get url() {
    return this.sectionUserForm.get('linkListGroup.url') as UntypedFormControl;
  }

  get fileUpload() {
    return this.sectionUserForm.get('linkListGroup.fileUpload') as UntypedFormControl;
  }

  get isActive() {
    return this.sectionUserForm.get('isActive') as UntypedFormControl;
  }

  get orderSequence() {
    return this.sectionUserForm.get('orderSequence') as UntypedFormControl;
  }

  get linkListGroup() {
    return this.sectionUserForm.get('linkListGroup') as UntypedFormGroup;
  }
}
